module.exports = __webpack_public_path__ + "static/sink-nav-square-33b179c2bdf12afeea55cee949a5d377.jpeg";